import React from 'react';
import { Input } from 'v3/components';

export default function CodeScannerInput({
  label = 'Código *',
  value,
  onChange,
  disabled = false,
  placeholder = 'Digite o código...',
}) {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Input
        label={label}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}
